<template>
    <div>
        <div v-if="gender === 'female'"><FemaleSVG class="inline"></FemaleSVG>{{ $t('text.female') }}</div>
        <div v-else-if="gender === 'male'"><MaleSVG class="inline"></MaleSVG> {{ $t('text.male') }}</div>
    </div>
</template>

<script>
    import FemaleSVG from "@/components/shared/svgs/FemaleSVG";
    import MaleSVG from "@/components/shared/svgs/MaleSVG";

    export default {
        name: "MissionDetailGender",
        props: ['gender'],
        components: { FemaleSVG, MaleSVG }
    }
</script>

<style scoped>

</style>